import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';
import { PERMISSION_KEYS } from 'constants-permissions';
import { SecurityRuleTypeEnum } from '../../../types/properties/PropertySecurity';

const NewStandDefinition: IntegrationDefinition = {
  hasCustomUI: true,
  name: IntegrationProviderEnum.Newstand,
  friendlyName: 'Newstand',
  description: `Content Generator`,
  category: IntegrationCategoryEnum.Content,
  platforms: [PlatformEnum.Mobile, PlatformEnum.Web],
  type: IntegrationTypeEnum.Api, // API or Webview? Both?
  settings: {
    baseUrl: {
      friendlyName: 'Base Url',
      description: 'The base URL of the Newstand API endpoint',
      type: 'Url',
      default: 'https://newstand.com/data/api/', // they version. auth call includes /v1/token-auth/
      editable: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    version: {
      friendlyName: 'Version',
      description:
        'The current version of the API. Used for Auth endpoints only',
      type: 'String',
      default: 'v1',
      editable: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  properties: {
    username: {
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    password: {
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    zone_id: {
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    membership_id: {
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  interactionData: {},
  mobilePermissions: [],
};

/**
 * @deprecated Use `NewstandDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { NewstandDefinition } from 'application-types';`
 */
export default NewStandDefinition;
